import React from "react";
import styled from "styled-components";
import settings from "../settings";
import { down } from "styled-breakpoints";
import getGridHeight from "@src/utils/getGridHeight";

interface Props {
	onClick?: () => void;
	className?: string;
}

const Text = styled.button`
	font-weight: 700;
	font-style: normal;
	font-family: ${settings.font.en};
	color: ${settings.color.accent};
	font-size: 14px;
	letter-spacing: 0.2222px;
	line-height: 1;
	padding-bottom: 12px;
	border-bottom: 2px solid ${settings.color.accent};
	${down("sm")} {
		display: flex;
		align-items: center;
		justify-content: center;
		height: ${getGridHeight({
			rows: 2,
		})}px;
		text-align: center;
		width: 100%;
		padding-top: 12px;
		border-top: 2px solid ${settings.color.accent};
	}
`;

const Viewmore: React.FC<Props> = (props) => {
	const { onClick, className } = props;
	return (
		<Text onClick={onClick} className={className} type="button">
			VIEW MORE
		</Text>
	);
};

export default styled(Viewmore)``;
